<script lang="ts">

  import { Button } from "$lib/components/ui/button"
  import type { CalendarDate } from "@internationalized/date"
  import ChevronLeftIcon from "@lucide/svelte/icons/chevron-left"
  import ChevronRightIcon from "@lucide/svelte/icons/chevron-right"

  let {
    value,
    onChange,
  }: {
    value: CalendarDate
    onChange: (value: CalendarDate) => void
  } = $props()

</script>

<div class="flex items-center justify-center">
  <Button
    variant="secondary"
    size="icon"
    class="size-7 rounded-full"
    onclick={() => onChange(value.subtract({ months: 1 }))}>
    <ChevronLeftIcon class="size-4"/>
  </Button>
  <div class="w-36 text-center text-sm tabular-nums tracking-tight">
    {value.format("MMMM yyyy")}
  </div>
  <Button
    variant="secondary"
    size="icon"
    class="size-7 rounded-full"
    onclick={() => onChange(value.add({ months: 1 }))}>
    <ChevronRightIcon class="size-4"/>
  </Button>
</div>
